module.exports = __webpack_public_path__ + "img/plain_btc.49d53c65.svg";